module.exports = __webpack_public_path__ + "static/media/awfxex32_118.d63d446c.ico";